import {
  alertType,
  CancelOrderAlert,
  CounteredToppedAlert,
  MutedAlert,
  NewOrderAlert,
  TradingNowAlert
} from './types'

export const subscribeToAlerts = () => ({ type: 'alerts.subscribe' } as const)
type SubscribeToAlertsAction = ReturnType<typeof subscribeToAlerts>

export const addTradingNowAlerts = (tradingNowAlerts: TradingNowAlert[]) =>
  ({
    type: 'alerts.addTradingNowAlerts',
    payload: { tradingNowAlerts }
  } as const)
export type AddTradingNowAlerts = ReturnType<typeof addTradingNowAlerts>

export const addNewOrderAlerts = (newOrderAlerts: NewOrderAlert[]) =>
  ({ type: 'alerts.addNewOrderAlerts', payload: { newOrderAlerts } } as const)
export type AddNewOrderAlerts = ReturnType<typeof addNewOrderAlerts>

export const addCancelOrderAlerts = (cancelOrderAlerts: CancelOrderAlert[]) =>
  ({
    type: 'alerts.addCancelOrderAlerts',
    payload: { cancelOrderAlerts }
  } as const)
export type AddCancelOrderAlerts = ReturnType<typeof addCancelOrderAlerts>

export const addCounteredToppedAlerts = (
  counteredToppedAlerts: CounteredToppedAlert[]
) =>
  ({
    type: 'alerts.addCounteredToppedAlerts',
    payload: { counteredToppedAlerts }
  } as const)
export type AddCounteredToppedAlerts = ReturnType<
  typeof addCounteredToppedAlerts
>

export const unsubscribeFromAlerts = () =>
  ({ type: 'alerts.unsubscribe' } as const)
type UnsubscribeFromAlertsAction = ReturnType<typeof unsubscribeFromAlerts>

export const muteAlert = (alert: MutedAlert) =>
  ({ type: 'alerts.muteAlert', payload: alert } as const)
export type MuteAlertAction = ReturnType<typeof muteAlert>

export const unmuteAlert = (type: alertType, securityId: number) =>
  ({ type: 'alerts.unmuteAlert', payload: { type, securityId } } as const)
export type UnmuteAlertAction = ReturnType<typeof unmuteAlert>

export type AlertsAction =
  | SubscribeToAlertsAction
  | AddTradingNowAlerts
  | AddCounteredToppedAlerts
  | AddNewOrderAlerts
  | UnsubscribeFromAlertsAction
  | MuteAlertAction
  | UnmuteAlertAction
  | AddCancelOrderAlerts
